export const GET_NOTIFICATIONS_FEED = 'GET_NOTIFICATIONS_FEED' // все уведомления по типам
export const VIEW_NOTIFICATION = 'VIEW_NOTIFICATION' // просмотр уведомления
export const VIEW_ALL = 'VIEW_ALL'
export const GET_ONE_NOTIFICATION = 'GET_ONE_NOTIFICATION' // одно уведомление (по сути пост)
export const GET_UNREAD_COUNT = 'GET_UNREAD_COUNT' // число непрочитанных уведомлений для сотрудника

export const GET_TMPL_NOTIFICATIONS = 'GET_TMPL_NOTIFICATIONS'
export const SAVE_TMPL_NOTIFICATIONS = 'SAVE_TMPL_NOTIFICATIONS'
